import React from "react";
import { CssBaseline, GlobalStyles } from "@mui/material";

const GlobalStyle = () =>
    <GlobalStyles
        styles={(theme) => ({
            'html, body, #root': {
                height: '100%'
            },
            body: {
                background: theme.body.background
            },
        })}
    />;

function LandingLayout(props) {
    
  return (
    <React.Fragment>
      <CssBaseline />
      <GlobalStyle />
      {props.children}
    </React.Fragment>
  );
}

export default LandingLayout;
